import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "payment-requests-details-modal-history" }
const _hoisted_2 = { class: "payment-requests-details-modal-history__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "container__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header__title" }, " История изменений ")
], -1)
const _hoisted_4 = { class: "container__content" }
const _hoisted_5 = {
  key: 0,
  class: "content__record"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "record__icon icon--gray" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }),
    /*#__PURE__*/_createElementVNode("polyline", { points: "12 6 12 12 16 14" })
  ])
], -1)
const _hoisted_7 = { class: "record__content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "content__title" }, "Создан путевой лист", -1)
const _hoisted_9 = { class: "content__date" }
const _hoisted_10 = {
  key: 1,
  class: "content__record"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "record__icon icon--blue" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" }),
    /*#__PURE__*/_createElementVNode("path", { d: "m21.854 2.147-10.94 10.939" })
  ])
], -1)
const _hoisted_12 = { class: "record__content" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "content__title" }, "Запрошена выплата", -1)
const _hoisted_14 = { class: "content__date" }
const _hoisted_15 = {
  key: 2,
  class: "content__record"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "record__icon icon--red" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M18 6 6 18" }),
    /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12" })
  ])
], -1)
const _hoisted_17 = { class: "record__content" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "content__title" }, "Отказ от оплаты", -1)
const _hoisted_19 = { class: "content__date" }
const _hoisted_20 = {
  key: 3,
  class: "content__record"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "record__icon icon--green" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M20 6 9 17l-5-5" })
  ])
], -1)
const _hoisted_22 = { class: "record__content" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "content__title" }, "Выплата произведена", -1)
const _hoisted_24 = { class: "content__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.waybill.createdAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatDate(_ctx.waybill.createdAt)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.waybill.waybillPayment && _ctx.waybill.waybillPayment.createdAt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.waybill.waybillPayment.createdAt)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.waybill.waybillPayment && _ctx.waybill.waybillPayment.resolvedAt && _ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 61)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDate(_ctx.waybill.waybillPayment.resolvedAt)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.waybill.waybillPayment && _ctx.waybill.waybillPayment.resolvedAt && _ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 60)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formatDate(_ctx.waybill.waybillPayment.resolvedAt)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}